export const Exit = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 22H12V20H4V4H12V2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22Z" fill="black"/>
        <path d="M7.98047 11V13H18.5864L14.2934 17.293L15.7074 18.707L21.7074 12.707C21.8949 12.5194 22.0002 12.2651 22.0002 12C22.0002 11.7348 21.8949 11.4805 21.7074 11.293L15.7074 5.29297L14.2934 6.70697L18.5864 11H7.98047Z" fill="black"/>
        </svg>
    );
  };